import classNames from 'classnames';

import { ButtonSize, ButtonWithState } from '@xemplo/button';
import { HeaderIcon } from '@xemplo/header-icon';

import * as S from './header.styles';
import { ModalHeaderProps } from './header.types';

export const ModalHeaderTestId = {
  headerContainer: 'modal-header-container',
  headerIcon: 'modal-header-icon',
  title: 'modal-header-title',
  headerButton: 'modal-header-button',
};

export const ModalHeader = ({
  headerBtn,
  headerIcon,
  title,
  showKeyline,
  showShadow,
  description,
}: ModalHeaderProps) => {
  return (
    <S.HeaderContainer
      data-testid={ModalHeaderTestId.headerContainer}
      className={classNames({ showKeyline, showShadow })}
    >
      {headerIcon && (
        <HeaderIcon {...headerIcon} data-testid={ModalHeaderTestId.headerIcon} />
      )}
      <S.HeaderTitle>
        <span className="title" data-testid={ModalHeaderTestId.title}>
          {title}
        </span>
        {description && <span className="description">{description}</span>}
      </S.HeaderTitle>
      {headerBtn && (
        <ButtonWithState
          {...headerBtn}
          size={ButtonSize.Small}
          className="header-btn"
          testId={ModalHeaderTestId.headerButton}
        >
          {headerBtn.label}
        </ButtonWithState>
      )}
    </S.HeaderContainer>
  );
};
